import * as apiHelper from './../helpers/apiHelper';
import * as loadingActions from './loadingActions';

export var getLandlord = (landlord) => {
	return {
		type: "GET_LANDLORD",
		landlord
	};
};

export var startGetLandlord = (id, options = null) => {
	return (dispatch, getState) => {
		var url = "landlords/" + id;

		return apiHelper.apiRequest(url, 'get', null, dispatch, getState, options).then((res) => {
			if (res.ok) {
				dispatch(getLandlord(res.json));
				return res.json;
			} else {
				dispatch(getLandlord(null));
				return false;
			}
		});
	};
};

export var getLandlordUnits = (id) => {
    return (dispatch, getState) => {
		var url = "landlords/" + id + "/units";
		
		return apiHelper.apiRequest(url, 'get', null, dispatch, getState).then((res) => {
			if (res.ok) {
				return res.json;
			} else {
				return [];
			}
		});
	};
};

export var getLandlordBuildings = (id) => {
   return (dispatch, getState) => {
     var url = "landlords/" + id + "/buildings";
     
     return apiHelper.apiRequest(url, 'get', null, dispatch, getState).then((res) => {
        if (res.ok) {
           return res.json;
        } else {
           return [];
        }
     });
  };
};

export var mergeLandlordUnits = (fromLandlordId, toLandlordId, ids, fromBuilding, isTransfer) => {
	return (dispatch, getState) => {
		dispatch(loadingActions.setSaving());
        const url = "landlords/merge-units";
        var formData = {ids, is_transfer: isTransfer ? "Y" : "N", from_landlord_id: fromLandlordId,
            to_landlord_id: toLandlordId, from_building: fromBuilding};

		return apiHelper.apiRequest(url, 'post', formData, dispatch, getState).then((res) => {
            dispatch(loadingActions.removeLoading());
			return res.ok;
		});
	}
};

export var restoreLandlord = (id) => {
	return {
		type: "RESTORE_LANDLORD",
		id
	}
}

export var startRestoreLandlord = (id) => {
	return (dispatch, getState) => {
		dispatch(loadingActions.setSaving());
		const url = "landlords/" + id + "/restore";

		return apiHelper.apiRequest(url, 'put', null, dispatch, getState).then((res) => {
			if (res.ok) {
				dispatch(restoreLandlord(id));
			} 
			dispatch(loadingActions.removeLoading());
			return res.ok ? null : res.errors;
		});	
	};
};



// WEBPACK FOOTER //
// ./src/actions/landlordActions.js